/**
 * ProductSurfaceContainer defines the specific UI containers/sections where products
 * are displayed. This enum is used for analytics and logging to track product impressions and interactions within different surface areas.
 */
export enum ProductSurfaceContainer {
  PRODUCT_SURFACE_CONTAINER_UNKNOWN = 'PRODUCT_SURFACE_CONTAINER_UNKNOWN',
  ASSORTMENT_PAGE_PRODUCTS = 'ASSORTMENT_PAGE_PRODUCTS',
  BOARDS_SAVED_PRODUCTS = 'BOARDS_SAVED_PRODUCTS',
  BRAND_PAGE_BUY_FROM_SAMPLES = 'BRAND_PAGE_BUY_FROM_SAMPLES',
  BRAND_PAGE_BUY_IT_AGAIN_PRODUCTS = 'BRAND_PAGE_BUY_IT_AGAIN_PRODUCTS',
  BRAND_PAGE_PRODUCTS = 'BRAND_PAGE_PRODUCTS',
  BRAND_PAGE_PRODUCTS_YOU_MIGHT_KNOW_POS = 'BRAND_PAGE_PRODUCTS_YOU_MIGHT_KNOW_POS',
  BRAND_PAGE_SIDE_CART = 'BRAND_PAGE_SIDE_CART',
  BRAND_PRODUCT_SEARCH_RESULTS_PRODUCTS = 'BRAND_PRODUCT_SEARCH_RESULTS_PRODUCTS',
  BRAND_VIDEO_LIBRARY_PRODUCTS = 'BRAND_VIDEO_LIBRARY_PRODUCTS',
  BRAND_VIDEO_PLAYER_PRODUCTS = 'BRAND_VIDEO_PLAYER_PRODUCTS',
  BUNDLES_PAGE_PRODUCTS = 'BUNDLES_PAGE_PRODUCTS',
  BUY_AGAIN_PRODUCTS = 'BUY_AGAIN_PRODUCTS',
  CART_PRODUCTS_YOU_MAY_LIKE = 'CART_PRODUCTS_YOU_MAY_LIKE',
  CART_PRODUCTS_YOU_MAY_LIKE_MARKETS = 'CART_PRODUCTS_YOU_MAY_LIKE_MARKETS',
  CART_RECENTLY_VISITED_PRODUCTS = 'CART_RECENTLY_VISITED_PRODUCTS',
  CATEGORY_PRODUCT_RESULTS_APPAREL_NEW_PRODUCTS_CAROUSEL = 'CATEGORY_PRODUCT_RESULTS_APPAREL_NEW_PRODUCTS_CAROUSEL',
  CATEGORY_PRODUCT_RESULTS_BESTSELLERS_BEAUTY_WELLNESS = 'CATEGORY_PRODUCT_RESULTS_BESTSELLERS_BEAUTY_WELLNESS',
  CATEGORY_PRODUCT_RESULTS_BUY_FROM_SAMPLES_CAROUSEL = 'CATEGORY_PRODUCT_RESULTS_BUY_FROM_SAMPLES_CAROUSEL',
  CATEGORY_PRODUCT_RESULTS_EURO_BEST_SELLERS = 'CATEGORY_PRODUCT_RESULTS_EURO_BEST_SELLERS',
  CATEGORY_PRODUCT_RESULTS_PRODUCTS = 'CATEGORY_PRODUCT_RESULTS_PRODUCTS',
  CATEGORY_PRODUCT_RESULTS_SHOWROOM_MOBILE_PRODUCT_BANNER = 'CATEGORY_PRODUCT_RESULTS_SHOWROOM_MOBILE_PRODUCT_BANNER',
  DIGEST_PAGE_SCREEN_BESTSELLERS_PRODUCT_GRID = 'DIGEST_PAGE_SCREEN_BESTSELLERS_PRODUCT_GRID',
  DIGEST_PAGE_SCREEN_BRAND_SPOTLIGHT_PRODUCTS = 'DIGEST_PAGE_SCREEN_BRAND_SPOTLIGHT_PRODUCTS',
  DISCOVER_PAGE_SCREEN_FEATURED_PRODUCTS = 'DISCOVER_PAGE_SCREEN_FEATURED_PRODUCTS',
  EXCLUSIVITY_PRODUCTS = 'EXCLUSIVITY_PRODUCTS',
  HOME_BUY_FROM_SAMPLE_REQUESTS = 'HOME_BUY_FROM_SAMPLE_REQUESTS',
  HOME_C2_C3_PRODUCTS_FOR_YOU = 'HOME_C2_C3_PRODUCTS_FOR_YOU',
  HOME_FEED = 'HOME_FEED',
  HOME_INSIGHTS_CAROUSEL = 'HOME_INSIGHTS_CAROUSEL',
  HOME_LOW_POS_STOCK_PRODUCTS = 'HOME_LOW_POS_STOCK_PRODUCTS',
  HOME_MARKET_C2_C3_PRODUCTS_FOR_YOU = 'HOME_MARKET_C2_C3_PRODUCTS_FOR_YOU',
  HOME_MARKET_PRODUCTS_YOU_MAY_LIKE = 'HOME_MARKET_PRODUCTS_YOU_MAY_LIKE',
  HOME_NEW_FROM_BRANDS_YOU_INTERACTED = 'HOME_NEW_FROM_BRANDS_YOU_INTERACTED',
  HOME_PERSONALIZED_COLLECTIONS = 'HOME_PERSONALIZED_COLLECTIONS',
  HOME_PRODUCTS_FROM_POS_SUGGESTIONS = 'HOME_PRODUCTS_FROM_POS_SUGGESTIONS',
  HOME_PRODUCTS_YOU_MAY_LIKE = 'HOME_PRODUCTS_YOU_MAY_LIKE',
  HOME_RECENTLY_SEARCHED_QUERY_PRODUCTS = 'HOME_RECENTLY_SEARCHED_QUERY_PRODUCTS',
  HOME_RECENTLY_VISITED_PRODUCTS_JUMP_BACK_IN = 'HOME_RECENTLY_VISITED_PRODUCTS_JUMP_BACK_IN',
  HOME_SHOP_BY_ATTRIBUTE_PRODUCT_CAROUSEL_V2 = 'HOME_SHOP_BY_ATTRIBUTE_PRODUCT_CAROUSEL_V2',
  HOME_SHOP_FROM_COUNTRY_CAROUSEL = 'HOME_SHOP_FROM_COUNTRY_CAROUSEL',
  LOGGED_OUT_CATEGORY_PRODUCT_RESULTS_PRODUCT_CAROUSEL = 'LOGGED_OUT_CATEGORY_PRODUCT_RESULTS_PRODUCT_CAROUSEL',
  LOGGED_OUT_HOME_BESTSELLER_PRODUCTS_CAROUSEL = 'LOGGED_OUT_HOME_BESTSELLER_PRODUCTS_CAROUSEL',
  LOGGED_OUT_HOME_GEO_PRODUCTS_CAROUSEL = 'LOGGED_OUT_HOME_GEO_PRODUCTS_CAROUSEL',
  LOGGED_OUT_HOME_GLOBAL_PRODUCTS_CAROUSEL = 'LOGGED_OUT_HOME_GLOBAL_PRODUCTS_CAROUSEL',
  MERCHANDISED_COLLECTIONS_PRODUCTS = 'MERCHANDISED_COLLECTIONS_PRODUCTS',
  MY_BRANDS_PRODUCTS = 'MY_BRANDS_PRODUCTS',
  NOW_ON_FAIRE_BRAND_PRODUCTS = 'NOW_ON_FAIRE_BRAND_PRODUCTS',
  POST_ORDER_SIMILAR_BRANDS_PRODUCTS = 'POST_ORDER_SIMILAR_BRANDS_PRODUCTS',
  PRODUCT_BASED_COLLECTION_PRODUCTS = 'PRODUCT_BASED_COLLECTION_PRODUCTS',
  PRODUCT_BASED_COLLECTION_SIDE_CART = 'PRODUCT_BASED_COLLECTION_SIDE_CART',
  PRODUCT_BROWSE_RECENTLY_VIEWED_RECOMMENDER = 'PRODUCT_BROWSE_RECENTLY_VIEWED_RECOMMENDER',
  PRODUCT_ECO_CAROUSEL = 'PRODUCT_ECO_CAROUSEL',
  PRODUCT_EVERGREEN_PREORDERS = 'PRODUCT_EVERGREEN_PREORDERS',
  PRODUCT_MINI_BRAND_SHOP_CONTEXTUAL = 'PRODUCT_MINI_BRAND_SHOP_CONTEXTUAL',
  PRODUCT_PAGE_MORE_FROM_MAKER = 'PRODUCT_PAGE_MORE_FROM_MAKER',
  PRODUCT_PAGE_MORE_FROM_MAKER_ALT = 'PRODUCT_PAGE_MORE_FROM_MAKER_ALT',
  PRODUCT_PAGE_PRODUCTS = 'PRODUCT_PAGE_PRODUCTS',
  PRODUCT_PAGE_SIDE_CART = 'PRODUCT_PAGE_SIDE_CART',
  PRODUCT_PAGE_SIMILAR_PRODUCTS = 'PRODUCT_PAGE_SIMILAR_PRODUCTS',
  PRODUCT_POPULAR_WITH_STORES_LIKE_YOURS = 'PRODUCT_POPULAR_WITH_STORES_LIKE_YOURS',
  PRODUCT_PRODUCTS_YOU_MIGHT_ALSO_LIKE = 'PRODUCT_PRODUCTS_YOU_MIGHT_ALSO_LIKE',
  PRODUCT_PRODUCTS_YOU_MIGHT_KNOW = 'PRODUCT_PRODUCTS_YOU_MIGHT_KNOW',
  PRODUCT_RECENTLY_VIEWED_PRODUCTS = 'PRODUCT_RECENTLY_VIEWED_PRODUCTS',
  PRODUCT_SHOP_BY_ATTRIBUTES = 'PRODUCT_SHOP_BY_ATTRIBUTES',
  REORDER_BRANDS_PAGE_BRAND_UPDATES_CAROUSEL = 'REORDER_BRANDS_PAGE_BRAND_UPDATES_CAROUSEL',
  SEARCH_PRODUCT_RESULTS_IRRELEVANCE_CAROUSEL = 'SEARCH_PRODUCT_RESULTS_IRRELEVANCE_CAROUSEL',
  SEARCH_PRODUCT_RESULTS_PRIMARY_RESULTS = 'SEARCH_PRODUCT_RESULTS_PRIMARY_RESULTS',
  SEARCH_PRODUCT_RESULTS_SUGGESTED_BRAND_PRODUCTS = 'SEARCH_PRODUCT_RESULTS_SUGGESTED_BRAND_PRODUCTS',
  SEE_MORE_PAGE_SCREEN_PRODUCTS_YOU_MAY_LIKE = 'SEE_MORE_PAGE_SCREEN_PRODUCTS_YOU_MAY_LIKE',
  SEE_MORE_PAGE_SCREEN_RECENTLY_VIEWED = 'SEE_MORE_PAGE_SCREEN_RECENTLY_VIEWED',
  ORDER_DETAILS_PRODUCTS = 'ORDER_DETAILS_PRODUCTS',
  CART_RECOMMENDATIONS = 'CART_RECOMMENDATIONS',
  FOLLOWED_BRANDS_PAGE_PRODUCTS = 'FOLLOWED_BRANDS_PAGE_PRODUCTS',
  SEARCH_PRODUCT_RESULTS_BI_PRODUCTS = 'SEARCH_PRODUCT_RESULTS_BI_PRODUCTS',
  POST_CHECKOUT_LOW_MINIMUM_PRODUCTS_CAROUSEL = 'POST_CHECKOUT_LOW_MINIMUM_PRODUCTS_CAROUSEL',
}
